import React from "react";
import { Tabs } from "antd";
import { FileTextOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "Common/global.scss";
import CompanyDoc from "./CompanyDoc";
import ReceivedDocuments from "./ReceivedDoc";

// Document Storage now holds both document areas in one place (per Hammad's
// Jul-2026 request): the "Company Documents" templates and the per-employee
// "Received Documents" folders, shown as two tabs. The old standalone
// /received-Documents route redirects here to the Received Documents tab
// (see App.js).
export default function DocumentsStore() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") === "received" ? "received" : "company";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="body flex-grow-1 px-3">
        <Tabs
          activeKey={activeTab}
          onChange={(key) =>
            setSearchParams(key === "received" ? { tab: "received" } : {}, { replace: true })
          }
          size="large"
          items={[
            {
              key: "company",
              label: (
                <span>
                  <FileTextOutlined /> Company Documents
                </span>
              ),
              children: <CompanyDoc />,
            },
            {
              key: "received",
              label: (
                <span>
                  <CloudUploadOutlined /> Received Documents
                </span>
              ),
              children: <ReceivedDocuments />,
            },
          ]}
        />
      </div>
    </DashboardLayout>
  );
}
